<!-- File upload (FILE_UPLOAD): a standalone uploader whose picked file POSTs
     to the compute API and re-renders the selected target chart(s)/table(s). -->
<div class="wf-section" *ngIf="active">
  <header class="wf-section-header">
    <h3>{{ host.layoutSectionTitle('upload', 'Upload settings') }}</h3>
  </header>
  <small class="control-hint">{{ host.layoutSectionHint('upload', 'The uploaded file is sent to the compute API and the response re-renders the selected target(s).') }}</small>

  <div class="control-group control-group-full" *ngIf="host.fieldEnabled('upload', 'targetCharts')">
    <label>{{ host.fieldLabel('upload', 'targetCharts', 'Target chart(s) / table(s)') }}</label>
    <ng-select
      #ssUploadTargets
      class="ss-select ss-select--multi ss-select--full"
      [class.is-open]="!!ssUploadTargets.isOpen?.()"
      appendTo="body"
      ngClass="ss-dropdown-panel"
      [items]="host.targetCharts"
      bindLabel="label"
      bindValue="value"
      [multiple]="true"
      [closeOnSelect]="false"
      [hideSelected]="false"
      [clearable]="true"
      [searchable]="true"
      placeholder="Select the chart(s) or table(s) the uploaded file updates"
      [(ngModel)]="host.selectedTargetCharts"
    ></ng-select>
    <small class="control-hint" *ngIf="!host.targetCharts.length">Add a chart or table to the dashboard first so it can be selected as a target.</small>
  </div>
  <ng-container *ngTemplateOutlet="apiCallConfigBlock; context: { kind: 'upload' }"></ng-container>

  <div class="control-row">
    <div class="control-group" *ngIf="host.fieldEnabled('upload', 'buttonLabel')">
      <label>{{ host.fieldLabel('upload', 'buttonLabel', 'Upload button label') }}</label>
      <input type="text" [(ngModel)]="fileUploadButtonLabel" placeholder="Upload file" />
    </div>
    <div class="control-group" *ngIf="host.fieldEnabled('upload', 'accept')">
      <label>{{ host.fieldLabel('upload', 'accept', 'Accepted file types') }}</label>
      <input type="text" [(ngModel)]="fileUploadAccept" placeholder=".xlsx,.xls,.csv" />
    </div>
  </div>
  <!-- No Format accordion here by design: File Upload tiles don't take
       card-header formatting (builder or published). -->
</div>
